module.exports = __webpack_public_path__ + "img/invert_colors.70cba4c8.svg";